<template>
  <div v-if="isLowAvailability" data-testid="pdp-lowstock-message" class="error-color medium margin-bottom-m">Low Stock</div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';
import { useUpc } from '@nuxt-common/media-card-large/app/composables/useUpc';

const emits = defineEmits(['low-availability-changed']);
const props = defineProps({
  productId: {
    type: [String, Number], // TODO only added number here to fix warning, need to finalize type and correct usage
    required: true,
  },
});

const { upcData, selectedUpcId } = useUpc(props.productId);
const currentUpcData = computed(() => upcData.value.upcs[selectedUpcId.value] || null);
const isLowAvailability = computed(() => currentUpcData.value?.availability?.lowAvailability || false);

watchEffect(() => {
  emits('low-availability-changed', isLowAvailability.value);
});

defineExpose({
  upcData,
  selectedUpcId,
  currentUpcData,
  isLowAvailability,
});
</script>
